<template>
    <div>
        <Breadcrumbs main="Admin" submain="Volunteer" title="Volunteer" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div style="max-width: fit-content;"> 
                                <router-link to="/volunteer/register">
                                    <button class="btn btn-primary" type="submit" style="display: flex; gap: 12px; align-items: center;">
                                        <i class="fa fa-light fa-plus"></i>
                                        <h7>Add New Volunteer</h7>
                                    </button>
                                </router-link>
                            </div>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="volunteer_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(user_name)="row">
                                            <div v-if="row.item.user_name">
                                                <p>{{ row.item.user_name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(email)="row">
                                            <div v-if="row.item.email">
                                                <p>{{ row.item.email }}</p>
                                            </div>
                                        </template>

                                        <template #cell(nid)="row">
                                            <div v-if="row.item.additional_info">
                                                <p>{{ row.item.additional_info.nid }}</p>
                                            </div>
                                        </template>

                                        <template #cell(phone_number)="row">
                                            <div v-if="row.item.additional_info">
                                                <p>{{ row.item.additional_info.phone_number }}</p>
                                            </div>
                                        </template>

                                        <template #cell(image)="row">
                                            <div v-if="row.item.additional_info">
                                                <img style="height: 70px;" :src="host + row.item.additional_info.photo" alt="">
                                            </div>
                                        </template>

                                        <template #cell(shelter)="row">
                                            <div v-if="row.item.additional_info">
                                                <div class="d-flex flex-column" style="gap: 6px;">
                                                    <div v-for="shelter, index in row.item.additional_info.shelter" :key="index">
                                                        <div class="d-flex">
                                                            <span>{{ shelter.name }}, </span>
                                                            <div class="ml-2">
                                                                <span v-if="shelter.shelter_type == 'mpds'">MPDS</span>
                                                                <span v-if="shelter.shelter_type == 'para_center'">Para Center</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteShelter(data.item.id)" title="Delete"></feather>
                                                </div>
    
                                                <div @click="editShelter(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Volunteer Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Volunteer" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>First Name</label>
                            <input class="form-control" type="text" placeholder="Enter your first name" v-model="edit_volunteer.first_name">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Last Name</label>
                            <input class="form-control" type="text" placeholder="Enter your last name" v-model="edit_volunteer.last_name">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input class="form-control" type="text" placeholder="Enter your email address" v-model="edit_volunteer.email">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Nid</label>
                            <input class="form-control" type="text" placeholder="Enter your nid no." v-model="edit_volunteer.nid">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Phone No</label>
                            <input class="form-control" type="text" placeholder="Enter your phone no." v-model="edit_volunteer.phone_number">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Address</label>
                            <input class="form-control" type="text" placeholder="Enter your address" v-model="edit_volunteer.address">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Shelter</label>
                            <multiselect v-model="assignedShelter" tag-placeholder="Add shelter" placeholder="Search or add a shelter" label="name" :max="shelter_list.length" track-by="id" :options="shelter_list" :multiple="true" :taggable="true"></multiselect>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Photo</label>
                            <div class="flex items-center">
                                <img v-if="show_edit_image" style="height: 60px;" :src="show_edit_image">
                                <input :class="edit_volunteer.photo ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="uploadEditFile">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Volunteer Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this volunteer?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    import Multiselect from 'vue-multiselect';
    
    export default {
        components: {
            loader,
            Multiselect
        },
    
        data() {
            return {
                host: myHost.host,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'user_name',
                        label: 'Volunteer',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    {
                        key: 'nid',
                        label: 'Nid No.',
                        sortable: true
                    },
                    {
                        key: 'phone_number',
                        label: 'Phone No.',
                        sortable: true
                    },
                    {
                        key: 'image',
                        label: 'Photo',
                        sortable: true
                    },
                    {
                        key: 'shelter',
                        label: 'Shelter',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                edit_volunteer: {
                    id: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    nid: '',
                    phone_number: '',
                    address: '',
                    shelter: [],
                    photo: null
                },
   
                assignedShelter: [], 
                show_edit_image: null,
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                shelter_list: state => state.shelter.shelter,
                volunteer_list: state => state.volunteer.volunteer,
                loading: state => state.volunteer.volunteerLoading,
                error: state => state.volunteer.volunteerError
            }),
    
            sortOptions() {
                // Create an options list from our fields
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
            this.$store.dispatch("volunteer/fetchVolunteer").then(() => {
                this.items = this.volunteer_list
                this.totalRows = this.volunteer_list.length;
            });
        },
    
        methods: {
            uploadEditFile(e) {
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.show_edit_image = e.target.result
                    this.edit_volunteer.photo = e.target.result;
                };
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            editShelter(detail) {
                this.edit_volunteer.id = detail.id ? detail.id : null
                this.edit_volunteer.first_name = detail.first_name ? detail.first_name : null
                this.edit_volunteer.last_name = detail.last_name ? detail.last_name : null
                this.edit_volunteer.email = detail.email ? detail.email : null
                this.edit_volunteer.nid = detail.additional_info.nid ? detail.additional_info.nid : null
                this.edit_volunteer.phone_number = detail.additional_info.phone_number ? detail.additional_info.phone_number : null
                this.edit_volunteer.address = detail.additional_info.address ? detail.additional_info.address : null
                this.assignedShelter = detail.additional_info.shelter ? detail.additional_info.shelter : null
                this.show_edit_image = detail.additional_info.photo ? this.host + detail.additional_info.photo : null
            },
    
            resetEditModal() {
                this.edit_volunteer.name = null
                this.edit_volunteer.upozila = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.assignedShelter.map(item => this.edit_volunteer.shelter.push(item.id));

                this.$store.dispatch("volunteer/updateVolunteer", {
                    id: this.edit_volunteer.id,
                    volunteer: this.edit_volunteer
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_volunteer.first_name = null
                        this.edit_volunteer.last_name = null
                        this.edit_volunteer.email = null
                        this.edit_volunteer.nid = null
                        this.edit_volunteer.phone_number = null
                        this.edit_volunteer.address = null
                        this.edit_volunteer.shelter = []
                        this.assignedShelter = []
                        this.edit_volunteer.phone_number = null
                        this.show_edit_image = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteShelter(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("volunteer/deleteVolunteer", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    